var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g0 = item.type === 0 ? (item.money / 100).toFixed(2) : null
    var g1 =
      item.type === 1 || item.type === 2 || item.type === 3
        ? (item.money / 100).toFixed(2)
        : null
    return {
      $orig: $orig,
      g0: g0,
      g1: g1,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }